export const VALIDATIONS = {
  urlRegex:
    //eslint-disable-next-line
    /(^https?:\/\/(aemlocal|wwwdev|wwwqa|wwwstage|preview|www)\.nvidia\.(com|cn)(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)/,
};

export const PATHS = {
  "/auth/gtc": "/assets/starfleet-auth/splash.js",
  "/auth/gtc/": "/assets/starfleet-auth/splash.js",
  "/auth/hints/": "/assets/starfleet-auth/hints/hints.js",
  "/auth/hints": "/assets/starfleet-auth/hints/hints.js",
  "/auth/aisummit": "/assets/starfleet-auth/splash.js",
  "/auth/aisummit/": "/assets/starfleet-auth/splash.js",
  "/auth/provider": "/assets/account/provider/bundle.js",
  "/auth/provider/": "/assets/account/provider/bundle.js",
};
